import { axiosPrivate } from 'app/utils';

import helpers from './helpers';

export default {
  async getOrderStats({ pharmacyId }) {
    const resourceLink = helpers.getResourceLink('/orders/count', { pharmacy_id: pharmacyId });

    const response = await axiosPrivate.get(resourceLink);
    if (response.data.error) helpers.throwError(response.data.error);
    if (!response.data.data?.[0]?.count) helpers.throwError('Failed to get orders stats');

    return response.data.data[0].count;
  },

  async getOrders({ pharmacyId, patientId, page, rowsPerPage }) {
    const resourceLink = helpers.getResourceLink('/orders', {
      pharmacy_id: pharmacyId,
      patient_id: patientId,
      page,
      limit: rowsPerPage,
    });

    const response = await axiosPrivate.get(resourceLink);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getOrdersForBatchToReady({ pharmacyId, order, gpSentDaysAgo }) {
    const resourceLink = helpers.getResourceLink('/orders/batch-to-ready', {
      pharmacy_id: pharmacyId,
      order,
      gp_sent_days_ago: gpSentDaysAgo,
    });

    const response = await axiosPrivate.get(resourceLink);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async batchMoveOrdersToReady({ orderIds, pharmacyId, gpSentDaysAgo }) {
    const requestUri = '/orders/batch-to-ready';
    const response = await axiosPrivate.put(requestUri, {
      order_ids: orderIds,
      pharmacy_id: pharmacyId,
      gp_sent_days_ago: gpSentDaysAgo,
    });
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async putOrder({ orderId, payload, params }) {
    const requestUri = helpers.getResourceLink(`/orders/${orderId}`, params);
    const response = await axiosPrivate.put(requestUri, payload);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getPrescriptionTemplatePDF({ orderId }) {
    const requestUri = `/orders/${orderId}/prescription-request/prescription-template`;
    const response = await axiosPrivate.get(requestUri);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async generateSignedPrescription({ orderId, pin }) {
    const requestUri = `/v3/orders/${orderId}/signed-prescription`;
    try {
      const response = await axiosPrivate.post(requestUri, { pin });

      if (response.data.error) helpers.throwError(response.data.error);

      return response;
    } catch (error) {
      if (error.response?.data?.message) {
        helpers.throwError(error.response.data);
      }
      throw error;
    }
  },

  async getGPLetterPDF({ orderId }) {
    const requestUri = `/orders/${orderId}/prescription-request/gp-letter`;
    const response = await axiosPrivate.get(requestUri);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async reassignOrderPharmacy({ orderId, pharmacyId }) {
    const requestUri = `/orders/${orderId}/reassign-pharmacy`;

    const response = await axiosPrivate.put(requestUri, { pharmacy_id: pharmacyId });
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },
};
